function StreamCbrRemuxRenderMptsdStatus({ stream }) {
  if (stream.cbr_remux_engine != 'mptsd') return <></>;
  if (!stream.started) {
    return <></>;
  } else if (!stream.mptsd_status || !stream.mptsd_status.works) {
    return <div className="m-px px-2 border-gray-200 border rounded-md text-red-500">
        Status: Internal crash
      </div>;
  } else {
    return <>
      <div className="m-px px-2 border-gray-200 border rounded-md">
        Status: ok
      </div>
      <div className="m-px px-2 border-gray-200 border rounded-md">
        Padding: {stream.mptsd_status.pad_pc}
      </div>
      <div className="m-px px-2 border-gray-200 border rounded-md">
        Mux bitrate: {Math.floor(stream.mptsd_status.output_rate_kbps)}k
      </div>
    </>
  };
}

export default function StreamCbrRemux({ stream }) {
  if (!stream.cbr_remux) return <></>;

  return <div className="flex my-px border-blue-100 border rounded-lg group hover:border-blue-200">
    <div className="px-2 bg-slate-200 rounded-l-lg w-28 flex-none">CBR Remux:</div>
    <div className="flex flex-wrap m-px items-center basis-auto lg:basis-5/12 xl:basis-8/12">
      <div className="m-px px-2 border-gray-200 border rounded-md">
        Target Bitrate: {stream.cbr_remux_bitrate_k}k
      </div>
      <div className="m-px px-2 border-gray-200 border rounded-md">
        Engine: {stream.cbr_remux_engine}
      </div>
      <StreamCbrRemuxRenderMptsdStatus stream={stream} />
    </div>
    </div> ;
}

